module.exports = "<div v-if=\"(data.firstLoad && isShow) || data.nextPage\"><slot></slot></div>";
